import React from 'react';
import { LegalPage } from '../components/legal/LegalPage';

const TermsPage = () => (
  <LegalPage title="Terms of Service" lastUpdated="February 10, 2026">
    <p>
      These Terms of Service ("<strong>Terms</strong>") govern your use of the Clayworks booking and commerce
      platform operated by Clayworks Spaces Technologies Pvt Ltd ("<strong>Clayworks</strong>", "we", "our"). By
      creating an account or making a booking, you agree to these Terms.
    </p>

    <h2>1. Eligibility</h2>
    <p>You must be at least 18 years old and capable of entering into a binding contract under Indian law.</p>

    <h2>2. Accounts</h2>
    <p>
      You're responsible for keeping your login credentials confidential and for any activity under your
      account. Notify us immediately at <strong>support@clayworks.co.in</strong> if you suspect unauthorized
      access.
    </p>

    <h2>3. Bookings</h2>
    <ul>
      <li>Bookings are confirmed only once payment (or credit deduction) has been successfully processed.</li>
      <li>Cancellations + refunds follow the policy displayed during checkout for each specific product (day pass, meeting room, Virtual Office, etc.).</li>
      <li>No-shows beyond a booked slot may be charged the full amount at our discretion.</li>
      <li>We reserve the right to refuse or cancel any booking that violates our community standards or applicable law.</li>
    </ul>

    <h2>4. Virtual Office subscriptions</h2>
    <ul>
      <li>Virtual Office subscriptions are 12-month annual commitments paid upfront.</li>
      <li>KYC verification is required before benefits are activated.</li>
      <li>Monthly credit grants (where applicable) do not roll over month-to-month unless explicitly stated in your plan.</li>
      <li>Non-refundable except by mutual agreement or admin discretion documented in writing.</li>
    </ul>

    <h2>5. Credit wallet</h2>
    <ul>
      <li>Monthly credits expire at the end of each billing month unless your plan includes carry-forward.</li>
      <li>Top-up credit packages purchased separately do not expire.</li>
      <li>Credits are non-transferable and have no cash value.</li>
    </ul>

    <h2>6. Payments + invoices</h2>
    <ul>
      <li>All prices are quoted in Indian Rupees (₹) and are exclusive of GST unless stated otherwise.</li>
      <li>GST invoices are auto-issued via Zoho Invoice on successful payment. You're responsible for sharing accurate GSTIN + billing details if input tax credit is claimed.</li>
      <li>Disputed transactions must be raised within 30 days of the charge.</li>
    </ul>

    <h2>7. Conduct</h2>
    <p>You agree not to:</p>
    <ul>
      <li>Use the Service for any unlawful purpose or to facilitate any illegal activity.</li>
      <li>Disrupt or attempt to gain unauthorized access to our systems.</li>
      <li>Harass other users, members, or staff at any Clayworks centre.</li>
      <li>Reproduce, resell, or sublicense any part of the Service without our written consent.</li>
    </ul>

    <h2>8. Intellectual property</h2>
    <p>
      All content, branding, software, and design elements of the Service are the property of Clayworks Spaces
      Technologies Pvt Ltd. You receive a limited, non-exclusive, revocable licence to use the Service for its
      intended purpose only.
    </p>

    <h2>9. Termination</h2>
    <p>
      We may suspend or terminate your account at any time for breach of these Terms or for fraudulent
      activity. You may close your account anytime by contacting <strong>support@clayworks.co.in</strong>;
      outstanding obligations (e.g., active subscriptions) remain enforceable.
    </p>

    <h2>10. Limitation of liability</h2>
    <p>
      To the maximum extent permitted by law, Clayworks's total liability for any claim arising out of the
      Service is limited to the amount you paid us in the 12 months preceding the claim. We are not liable
      for indirect, incidental, or consequential damages.
    </p>

    <h2>11. Governing law</h2>
    <p>
      These Terms are governed by the laws of India. Any disputes will be subject to the exclusive
      jurisdiction of the courts at Bengaluru, Karnataka.
    </p>

    <h2>12. Changes to these Terms</h2>
    <p>
      We may revise these Terms from time to time. We'll notify you of material changes at least 14 days in
      advance. Continued use of the Service after the effective date constitutes acceptance.
    </p>

    <h2>13. Contact</h2>
    <p>
      Clayworks Spaces Technologies Pvt Ltd<br />
      Email: <strong>support@clayworks.co.in</strong><br />
      Address: Clayworks Mini Forest, 3rd Floor, Site No. 74, Mass Complex, 15th Cross Road, Sarakki Industrial
      Layout, Dollar Layout, 3rd Phase, J. P. Nagar, Bengaluru, Karnataka, India.
    </p>
  </LegalPage>
);

export default TermsPage;
